import React, { useContext, useEffect, useState } from 'react';
import { ElementConfigType } from '../../../store/type';
import { PageEditorStoreContext } from '../../../store/PageEditorStore';
import style from '../../SingleSuperTabComponent/SingleSuperTab.module.scss';
import { MyComponentType } from '@/pages2/DetailedDescription/component-factory/component-types';
import { toJS } from 'mobx';
import { ComponentIdEnum } from '@/pages2/DetailedDescription/component-factory/ComponentIdEnum';
import { lazy } from 'ice';
import { ConfigHOC } from '../../../HOC';
import { createUniqueId } from '@/utils';

type Props = ElementConfigType;

export const TabComponents_V2_A: MyComponentType<Props> = (props: Props) => {
  const pageEditorStore = useContext(PageEditorStoreContext);
  const { elements, id, privateSchema, parentNodeIsBody } = props;
  const [tabDate1, setTabDate1] = useState<ElementConfigType[]>([]); // 切换按键
  const [tabContentDate2, setTabContentDate2] = useState<ElementConfigType[]>([]);
  const [tabContentDate3, setTabContentDate3] = useState<ElementConfigType[]>([]);
  const [tabContentDate4, setTabContentDate4] = useState<ElementConfigType[]>([]);
  const [clickIndex, setClickIndex] = useState(0);
  // @ts-ignore
  const { isReverse } = privateSchema;

  useEffect(() => {
    // 设置 点击tap 数据
    setTabDate1(elements.map((d) => d.elements[0]));
    setTabContentDate2(elements.map((d) => d.elements[1]));
    setTabContentDate3(elements.map((d) => d.elements[2]));
    setTabContentDate4(elements.map((d) => d.elements[3]));
    // elements长度变化 变化 重新选择第一个
    if (elements.length / 4 < clickIndex + 1) {
      setClickIndex(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [elements]);

  const handleTabClick = (i) => {
    setClickIndex(i);
  };

  const flexRow = isReverse ? 'md:flex-row-reverse' : 'md:flex-row';
  const flexPadding = !isReverse ? 'md:pr-24' : 'md:pl-24';

  const isButtonShape = privateSchema?.buttonShape === 'circular';
  const ButtonShapeClass = isButtonShape
    ? 'single-tab-title-circular overflow-hidden w-16 md:w-20 2lg:w-24 h-12 md:h-16 2lg:h-20 mt-4 pr-4'
    : 'single-tab-title';
  const flexGrowClass = parentNodeIsBody ? '' : 'flex-grow';
  const itemsEndClass = parentNodeIsBody ? '' : 'items-end';

  console.log('!!!!ele', elements);

  return (
    <>
      {/* pc端 */}
      <div
        className={`${style.singleSuper} hidden md:flex flex-col ${flexRow}`}
        style={Object.assign(parentNodeIsBody ? { paddingTop: 16, paddingBottom: 16 } : {})}
        id={id}
      >
        <div className={`w-full md:w-1/2 flex flex-col justify-center ${flexPadding}`}>
          <div className={`flex  ${flexGrowClass} flex-col justify-center`}>
            {(tabContentDate2.length === 0 ? elements.map((d) => d.elements[1]) : tabContentDate2).map((d, index) => {
              return (
                <div key={d.nodeId} className={`w-full item flex ${clickIndex !== index ? 'hidden' : ''}`}>
                  <div className="w-full">
                    <props.ComponentBasicRender {...toJS(d)} />
                  </div>
                </div>
              );
            })}
            {(tabContentDate3.length === 0 ? elements.map((d) => d.elements[2]) : tabContentDate3).map((d, index) => {
              return (
                <div key={d.nodeId} className={`w-full item flex ${clickIndex !== index ? 'hidden' : ''}`}>
                  <div className="w-full">
                    <props.ComponentBasicRender {...toJS(d)} />
                  </div>
                </div>
              );
            })}
          </div>

          <div className={`flex flex-wrap ${itemsEndClass}  z-10 pr-20`}>
            {(tabDate1.length === 0 ? elements.map((d) => d.elements[0]) : tabDate1).map((d, index) => {
              return (
                <div
                  style={!pageEditorStore.isRenderHtml ? { border: '1px solid #F7C001' } : {}}
                  key={d.nodeId}
                  className={`${ButtonShapeClass} ${clickIndex === index ? 'gold' : ''} flex justify-center`}
                  onClick={() => {
                    handleTabClick(index);
                  }}
                >
                  <button className={`block ${isButtonShape ? '' : 'mr-6 mt-5 pb-1'}`}>
                    <props.ComponentBasicRender {...toJS(d)} height="h-10" />
                  </button>
                </div>
              );
            })}
          </div>
        </div>

        <div className="w-full md:w-1/2 flex flex-col justify-center">
          {(tabContentDate4.length === 0 ? elements.map((d) => d.elements[3]) : tabContentDate4).map((d, index) => {
            return (
              <div key={d.nodeId} className={`w-full item flex ${clickIndex !== index ? 'hidden' : ''}`}>
                <div className="w-full">
                  <props.ComponentBasicRender {...toJS(d)} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {/* 移动端 */}
      <div
        className={`${style.singleSuper} md:hidden flex flex-col ${flexRow}`}
        style={Object.assign(parentNodeIsBody ? { paddingTop: 16, paddingBottom: 16 } : {})}
        id={id}
      >
        <div className={`w-full md:w-1/2 flex flex-col justify-center ${flexPadding}`}>
          <div>
            {(tabContentDate2.length === 0 ? elements.map((d) => d.elements[1]) : tabContentDate2).map((d, index) => {
              return (
                <div key={d.nodeId} className={`w-full item flex ${clickIndex !== index ? 'hidden' : ''}`}>
                  <div className="w-full mt-5">
                    <props.ComponentBasicRender {...toJS(d)} />
                  </div>
                </div>
              );
            })}
            {(tabContentDate3.length === 0 ? elements.map((d) => d.elements[2]) : tabContentDate3).map((d, index) => {
              return (
                <div key={d.nodeId} className={`w-full item flex ${clickIndex !== index ? 'hidden' : ''}`}>
                  <div className="w-full">
                    <props.ComponentBasicRender {...toJS(d)} />
                  </div>
                </div>
              );
            })}
          </div>
          <div className="w-full md:w-1/2 flex flex-col justify-center">
            {(tabContentDate4.length === 0 ? elements.map((d) => d.elements[3]) : tabContentDate4).map((d, index) => {
              return (
                <div key={d.nodeId} className={`w-full item flex ${clickIndex !== index ? 'hidden' : ''}`}>
                  <div className="w-full">
                    <props.ComponentBasicRender {...toJS(d)} />
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="flex flex-nowrap overflow-x-auto z-10 ">
          {(tabDate1.length === 0 ? elements.map((d) => d.elements[0]) : tabDate1).map((d, index) => {
            const toJSD = toJS(d);
            // 这里处理是为了让移动端文字不换行
            if (toJSD.elements[0]) {
              toJSD.elements[0].styles = { ...(toJSD?.elements[0]?.styles || {}) };
            }

            return (
              <div
                style={!pageEditorStore.isRenderHtml ? { border: '1px solid #F7C001' } : {}}
                key={d.nodeId}
                className={`${ButtonShapeClass} ${clickIndex === index ? 'gold' : ''} flex justify-center `}
                onClick={() => {
                  handleTabClick(index);
                }}
              >
                <button className={`block ${isButtonShape ? '' : 'mr-6 mt-5 pb-1'}`}>
                  <props.ComponentBasicRender {...toJSD} height="h-10" />
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

const ConfigForm = lazy(() => import('../../../components-with-definition/TabComponents_V2_A_Definition'));

const fillComponentsList = [
  [
    {
      componentId: ComponentIdEnum.TEXT_CONTENT_COMPONENT, // 点击的 文本容器
      componentName: '内容文本组件',
      privateSchema: {
        text: '48" x 30"',
        opacity: 0.5,
      },
    },
    {
      componentId: ComponentIdEnum.TEXT_TITLE_COMPONENT, // 标题容器
      componentName: '标题文本组件_1',
      privateSchema: {
        text: '48" x 30"',
        isShowUnderline: false,
        fontSize: 28, // 16
        fontWeight: 400,
        // eslint-disable-next-line @iceworks/best-practices/recommend-add-line-height-unit
        lineHeight: 28, // 24
      },
    },
    {
      componentId: ComponentIdEnum.TEXT_CONTENT_COMPONENT, // 文本容器
      componentName: '内容文本组件',
      styles: {
        paddingTop: 16,
      },
      privateSchema: {
        fontWeight: 400,
        text: 'A one-piece design is to make the assembly easier with a more sturdy desktop.',
      },
    },
    {
      componentId: ComponentIdEnum.IMG_COMPONENT,
      componentName: '图片组件_1',
      config: { src: 'https://cdn.resource.youniverse.cc/d2c-app/R3SpDV8nWeFkMyXDH41Xw.jpg' },
    }, // 图片容器
  ],
  [
    {
      componentId: ComponentIdEnum.TEXT_CONTENT_COMPONENT,
      componentName: '内容文本组件',
      privateSchema: {
        text: '55" x 28"',
        opacity: 0.5,
      },
    },
    {
      componentId: ComponentIdEnum.TEXT_TITLE_COMPONENT,
      componentName: '标题文本组件_1',
      privateSchema: {
        text: '55" x 28"',
        isShowUnderline: false,
        fontSize: 28, // 16
        fontWeight: 400,
        // eslint-disable-next-line @iceworks/best-practices/recommend-add-line-height-unit
        lineHeight: 28, // 24
      },
    },
    {
      componentId: ComponentIdEnum.TEXT_CONTENT_COMPONENT,
      componentName: '内容文本组件',
      styles: {
        paddingTop: 16,
      },
      privateSchema: {
        fontWeight: 400,
        text: 'A one-piece design is to make the assembly easier with a more sturdy desktop.',
      },
    },
    {
      componentId: ComponentIdEnum.IMG_COMPONENT,
      componentName: '图片组件_1',
      config: { src: 'https://cdn.resource.youniverse.cc/d2c-app/QZKaZHXzTToel_3BnRJLN.jpg' },
    },
  ],
];

const generateSubContainersNode = new Array(2).fill(null).map((_, tabIndex) => {
  const tabSubComponents = fillComponentsList[tabIndex];
  return {
    componentId: ComponentIdEnum.TAB_V2_A_CHILD,
    elements: new Array(4).fill(null).map((_item, index) => {
      const nodeId = createUniqueId();
      const subComponent = tabSubComponents[index];

      return {
        nodeId,
        index,
        componentId: 'Basic-Component',
        componentName: '基本容器',
        isSlot: true,
        config: {},
        styles: {}, // 组件通用css
        composeStyle: [
          {
            id: `default_${nodeId}`,
            name: '默认规则',
            type: 'DEFAULT',
            minWidth: 0,
            maxWidth: 0,
            rules: {},
          },
        ],
        privateSchema: {}, // 组件自己的属性 不能通用的部分
        elements: [
          {
            ...subComponent,
            nodeId: createUniqueId(),
            parentNodeId: nodeId,
            index: 1,
            elements: [],
          },
        ],
      };
    }),
  };
});

TabComponents_V2_A.definition = {
  id: ComponentIdEnum.TAB_V2_A_COMPONENT,
  name: 'Tab切换组件V2',
  icon: 'https://cdn.resource.youniverse.cc/d2c-app-dev/1F9FgNhXRqND8g7b6Dprb',
  config: {},
  styles: {},
  privateSchema: {
    subContainersNode: generateSubContainersNode,
    isReverse: true, // 是否翻转
    buttonShape: 'rectangle',
  },
  category: 'interactive',
  configForm: ConfigHOC(ConfigForm),
};
